import { Banner } from "@/ui/Banner";
import { Col, Row } from "react-bootstrap";
import { DynamicText } from "@/ui/DynamicText";
import { useLocale } from "@/hooks/useLocale";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const SpecialismsPageBannerSection = ({ className }) => {
  const locale = useLocale();

  return (
    <Banner
      className={className}
      title={<DynamicText path={`page.specialisms.banner.title.${locale}`} tag="h1" />}
      image={{ path: `page.specialisms.banner.image`, src: "/assets/banners/default.png" }}
    >
      <Row>
        <Col xs={12} md={6}>
          <DynamicHtml path={`page.specialisms.banner.text.${locale}`} />
        </Col>
      </Row>
    </Banner>
  );
};
